import { ActionResult } from './Common';
import { UserProfileFields } from '../types';

export const UPDATE_USER_PROFILE = 'UPDATE_USER_PROFILE';
export type UPDATE_USER_PROFILE = typeof UPDATE_USER_PROFILE;

export interface UpdateUserProfile {
    type: UPDATE_USER_PROFILE;
    value: UserProfileFields;
}

export type UserAction = UpdateUserProfile | ActionResult;

export const updateUserProfile = (fields: UserProfileFields): UpdateUserProfile => {
    return {
        type: UPDATE_USER_PROFILE,
        value: fields
    };
};